import { useState } from 'react';
import { ChevronRight, Check, Star, Award, Settings, ShoppingCart, Clock, Shield, Phone, Mail, MapPin } from 'lucide-react';
import img1 from '../components/images/Sunmi/sunmi_cover.png';
import img2 from '../components/images/Sunmi/SUNMI_COVER2.png';
import img3 from '../components/images/Sunmi/l2s.png';
import img4 from '../components/images/Sunmi/t3pro.png';
import img5 from '../components/images/Sunmi/v2s.png';
import img6 from '../components/images/Sunmi/v3mix.png';
import img7 from '../components/images/Sunmi/d2.png';
import img8 from '../components/images/Sunmi/t2.png';

const SunmiClaude = () => {
  const [activeTab, setActiveTab] = useState('all');
  const [hoveredProduct, setHoveredProduct] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const sunmiProducts = [img3, img4, img5, img6, img7, img8];

  const products = [
    {
      id: 1,
      name: "Sunmi V3 Mix",
      category: "Mobile terminals",
      type: "Smart POS Terminal",
      price: "Contact for pricing",
      features: [
        "15.6\" Large Touch Display",
        "Android 9.0 OS",
        "Quad-core 2.0GHz Processor",
        "Built-in Printer",
        "Face Recognition"
      ],
      description: "The V3 Mix is an all-in-one smart POS terminal designed for retail and restaurant environments. With a large 15.6\" touch display and built-in printer, it combines powerful performance with elegant design.",
      isNew: true,
      isBestseller: true,
      image: img6
    },
    {
      id: 2,
      name: "Sunmi V2S",
      category: "Mobile terminals",
      type: "Mobile POS Terminal",
      price: "Contact for pricing",
      features: [
        "5.99\" HD Touch Display",
        "Android 7.1 OS",
        "Quad-core Processor",
        "Built-in Printer",
        "4G/WiFi Connectivity"
      ],
      description: "The V2S is a handheld POS terminal perfect for queue-busting and table service. Compact yet powerful with an integrated printer and barcode scanner.",
      isNew: false,
      isBestseller: true,
      image: img5
    },
    {
      id: 3,
      name: "Sunmi L2S",
      category: "Mobile terminals",
      type: "Desktop POS Terminal",
      price: "Contact for pricing",
      features: [
        "14\" Touch Display",
        "Android 7.1 OS",
        "High-speed Thermal Printer",
        "Dual Display Option",
        "Multiple Interface Ports"
      ],
      description: "The L2S is a sophisticated desktop POS solution with a sleek design. Features a high-speed printer and optional customer-facing display for enhanced service.",
      isNew: false,
      isBestseller: false,
      image: img3
    },
    {
      id: 4,
      name: "Sunmi T2 Desktop",
      category: "Desktop terminals",
      type: "Smart Desktop Terminal",
      price: "Contact for pricing",
      features: [
        "15.6\" Full HD Display",
        "Android 7.1 OS",
        "Powerful Quad-core CPU",
        "Multiple I/O Ports",
        "Elegant Design"
      ],
      description: "The T2 Desktop terminal combines powerful performance with beautiful design. Perfect for high-volume retail environments requiring sophisticated POS solutions.",
      isNew: false,
      isBestseller: false,
      image: img8
    },
    {
      id: 5,
      name: "Sunmi D2 Desktop",
      category: "Desktop terminals",
      type: "Mini Desktop POS",
      price: "Contact for pricing",
      features: [
        "HD touchscreen with anti-fingerprint coating",
        "Quad-core processor for efficient performance",
        "2GB/4GB RAM and 16GB/32GB ROM options",
        "Connectivity: Wi-Fi, Bluetooth, Ethernet",
        "Compact and modern design"
      ],
      description: "The SUNMI D2 is a compact and cost-effective desktop POS system designed for small to medium-sized businesses. It offers essential functionalities in a sleek form factor, making it ideal for retail and hospitality environments.",
      isNew: false,
      isBestseller: false,
      image: img7
    },
    {
      id: 6,
      name: "Sunmi T3 Pro",
      category: "Desktop terminals",
      type: "Performant desktop pos",
      price: "Contact for pricing",
      features: [
        "Adjustable Viewing Angle",
        "Customizable Configurations",
        "Powerful Processor",
        "Low Maintenance",
        "Fingerprint unlocking"
      ],
      description: "The SUNMI T3 Pro is a flagship desktop POS terminal engineered for high-traffic retail and hospitality sectors. It offers advanced processing power, a premium display, and extensive connectivity options to streamline operations.",
      isNew: true,
      isBestseller: false,
      image: img4
    }
  ];

  const filteredProducts = activeTab === 'all' 
    ? products 
    : products.filter(product => product.category === activeTab);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white mt-12 font-poppins">
      {/* Hero Banner */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0  z-10"></div>
        <img 
          src={img2} 
          alt="Sunmi Hero" 
          className="w-full object-contain"
        />
       
      </section>

      {/* Product Gallery Section */}
      <section className="py-12 bg-gradient-to-r from-gray-50 to-gray-100">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-8">
            <p className="text-orange-600 font-semibold text-sm uppercase tracking-wider mb-2">
              Trusted by businesses across Saudi Arabia
            </p>
            <div className="w-20 h-1 bg-orange-500 mx-auto rounded-full"></div>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
            {sunmiProducts.map((product, index) => (
              <div 
                key={index} 
                className="bg-white rounded-xl p-4 shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 grayscale hover:grayscale-0"
              >
                <img 
                  src={product} 
                  alt={`Product ${index + 1}`} 
                  className="w-full h-32 object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section id="products" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-12">
            <div className="mb-6 lg:mb-0">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
                Our Sunmi Product Range
              </h2>
              <div className="w-24 h-1.5 bg-orange-500 rounded-full mb-4"></div>
              <p className="text-gray-600 text-lg max-w-2xl">
                Discover our comprehensive range of Sunmi POS terminals and printing solutions designed for modern businesses.
              </p>
            </div>
            
            <div className="flex flex-wrap gap-3">
              <button 
                onClick={() => setActiveTab('all')}
                className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 ${
                  activeTab === 'all' 
                    ? 'bg-orange-500 text-white shadow-lg transform scale-105' 
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }`}
              >
                All Products
              </button>
              <button 
                onClick={() => setActiveTab('Desktop terminals')}
                className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 ${
                  activeTab === 'Desktop terminals' 
                    ? 'bg-orange-500 text-white shadow-lg transform scale-105' 
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }`}
              >
                Desktop
              </button>
              <button 
                onClick={() => setActiveTab('Mobile terminals')}
                className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 ${
                  activeTab === 'Mobile terminals' 
                    ? 'bg-orange-500 text-white shadow-lg transform scale-105' 
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }`}
              >
                Mobile
              </button>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredProducts.map((product) => (
              <div 
                key={product.id}
                onMouseEnter={() => setHoveredProduct(product.id)}
                onMouseLeave={() => setHoveredProduct(null)}
                className={`bg-white rounded-2xl shadow-lg overflow-hidden transition-all duration-500 ${
                  hoveredProduct === product.id ? 'transform -translate-y-3 shadow-2xl' : ''
                }`}
              >
                <div className="relative bg-gradient-to-br from-gray-50 to-gray-100 p-6">
                  {product.isNew && (
                    <span className="absolute top-4 left-4 bg-orange-500 text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-md z-10">
                      NEW
                    </span>
                  )}
                  {product.isBestseller && (
                    <span className="absolute top-4 right-4 bg-amber-400 text-gray-900 text-xs font-bold px-3 py-1.5 rounded-full shadow-md z-10">
                      BESTSELLER
                    </span>
                  )}
                  <img 
                    src={product.image} 
                    alt={product.name}
                    className={`w-full h-56 object-contain transition-transform duration-500 ${
                      hoveredProduct === product.id ? 'scale-110' : 'scale-100'
                    }`}
                  />
                </div>
                
                <div className="p-6">
                  <div className="flex justify-between items-center mb-3">
                    <span className="bg-orange-100 text-orange-700 text-xs font-semibold px-3 py-1 rounded-full">
                      {product.type}
                    </span>
                    <span className="text-orange-600 font-bold text-sm">
                      {product.price}
                    </span>
                  </div>
                  
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">
                    {product.name}
                  </h3>
                  
                  <p className="text-gray-600 text-sm mb-6 line-clamp-3">
                    {product.description}
                  </p>
                  
                  <div className="mb-6">
                    <h6 className="text-xs font-bold text-gray-500 uppercase mb-3 tracking-wide">
                      Key Features
                    </h6>
                    <ul className="space-y-2">
                      {product.features.slice(0, 3).map((feature, i) => (
                        <li key={i} className="flex items-start text-sm text-gray-700">
                          <Check size={16} className="text-orange-500 mr-2 flex-shrink-0 mt-0.5" />
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                  
                  <a 
                    href={`/products/${product.id}`}
                    className="flex items-center justify-between w-full bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-semibold py-3 px-6 rounded-xl transition-all duration-300 group"
                  >
                    <span>Explore Now</span>
                    <ChevronRight 
                      size={20} 
                      className={`transition-transform duration-300 ${
                        hoveredProduct === product.id ? 'translate-x-2' : ''
                      }`}
                    />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-20 bg-gradient-to-br from-orange-50 via-white to-cyan-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Why Choose Us
            </h2>
            <div className="w-24 h-1.5 bg-orange-500 mx-auto rounded-full mb-6"></div>
            <p className="text-gray-600 text-lg max-w-3xl mx-auto">
              As the authorized Sunmi dealer in Dubai, we provide premium POS solutions with exceptional service and support.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { 
                icon: <Shield className="text-orange-500" size={40} />, 
                title: "Authorized Dealer", 
                description: "Official Sunmi partner with genuine products and manufacturer warranty" 
              },
              { 
                icon: <Settings className="text-orange-500" size={40} />, 
                title: "Technical Support", 
                description: "Expert installation and ongoing maintenance from certified technicians" 
              },
              { 
                icon: <Clock className="text-orange-500" size={40} />, 
                title: "Fast Delivery", 
                description: "Quick delivery and setup of your POS system across Dubai" 
              },
              { 
                icon: <Award className="text-orange-500" size={40} />, 
                title: "Quality Assurance", 
                description: "Only the highest quality products that meet international standards" 
              },
              { 
                icon: <Star className="text-orange-500" size={40} />, 
                title: "Customer Satisfaction", 
                description: "Dedicated to your satisfaction with personalized solutions" 
              },
              { 
                icon: <ShoppingCart className="text-orange-500" size={40} />, 
                title: "Complete Solutions", 
                description: "End-to-end retail and hospitality technology solutions" 
              }
            ].map((feature, index) => (
              <div 
                key={index}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
              >
                <div className="flex justify-center mb-4">
                  <div className="bg-orange-100 p-4 rounded-2xl">
                    {feature.icon}
                  </div>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3 text-center">
                  {feature.title}
                </h4>
                <p className="text-gray-600 text-center">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-gradient-to-r from-orange-600 to-cyan-600">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
            <div className="text-white">
              <h3 className="text-3xl md:text-4xl font-bold mb-4">
                Ready to upgrade your business technology?
              </h3>
              <p className="text-xl text-orange-50">
                Contact us today for a consultation and product demonstration.
              </p>
            </div>
            <a 
              href="#contact" 
              className="bg-white text-orange-600 hover:bg-gray-100 font-bold py-4 px-10 rounded-full transition-all duration-300 transform hover:scale-105 shadow-xl whitespace-nowrap"
            >
              Get in Touch
            </a>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
            <div className="lg:col-span-2">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                Contact Us
              </h2>
              <div className="w-24 h-1.5 bg-orange-500 rounded-full mb-6"></div>
              <p className="text-gray-600 mb-8">
                Our team of experts is ready to help you find the perfect Sunmi solution for your business needs.
              </p>
              
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="bg-orange-100 p-4 rounded-2xl mr-4">
                    <MapPin className="text-orange-600" size={24} />
                  </div>
                  <div>
                    <h5 className="font-bold text-gray-900 mb-1">Location</h5>
                    <p className="text-gray-600">Oud Metha, United Arab Emirates</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="bg-orange-100 p-4 rounded-2xl mr-4">
                    <Phone className="text-orange-600" size={24} />
                  </div>
                  <div>
                    <h5 className="font-bold text-gray-900 mb-1">Phone</h5>
                    <p className="text-gray-600">+973 33711399</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="bg-orange-100 p-4 rounded-2xl mr-4">
                    <Mail className="text-orange-600" size={24} />
                  </div>
                  <div>
                    <h5 className="font-bold text-gray-900 mb-1">Email</h5>
                    <p className="text-gray-600">sales@sensetechme.com</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="lg:col-span-3">
              <div className="bg-gradient-to-br from-gray-50 to-white rounded-3xl shadow-2xl p-8 md:p-10">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">
                  Send us a message
                </h3>
                <form onSubmit={handleSubmit}>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                    <input 
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      placeholder="Your name"
                      className="w-full px-6 py-4 rounded-xl border border-gray-300 focus:border-orange-500 focus:ring-2 focus:ring-orange-200 outline-none transition-all"
                      required
                    />
                    <input 
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="Your email"
                      className="w-full px-6 py-4 rounded-xl border border-gray-300 focus:border-orange-500 focus:ring-2 focus:ring-orange-200 outline-none transition-all"
                      required
                    />
                  </div>
                  
                  <input 
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Your phone number"
                    className="w-full px-6 py-4 rounded-xl border border-gray-300 focus:border-orange-500 focus:ring-2 focus:ring-orange-200 outline-none transition-all mb-6"
                    required
                  />
                  
                  <select 
                    name="subject"
                    value={formData.subject}
                    onChange={handleInputChange}
                    className="w-full px-6 py-4 rounded-xl border border-gray-300 focus:border-orange-500 focus:ring-2 focus:ring-orange-200 outline-none transition-all mb-6"
                    required
                  >
                    <option value="">Select an option</option>
                    <option value="pos">POS Terminals</option>
                    <option value="printer">Printers</option>
                    <option value="weighing">Weighing Scales</option>
                    <option value="other">Other Inquiry</option>
                  </select>
                  
                  <textarea 
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    rows="5"
                    placeholder="How can we help you?"
                    className="w-full px-6 py-4 rounded-xl border border-gray-300 focus:border-orange-500 focus:ring-2 focus:ring-orange-200 outline-none transition-all mb-6"
                    required
                  ></textarea>
                  
                  <button 
                    type="submit"
                    className="w-full bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-bold py-4 px-8 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg"
                  >
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SunmiClaude;